import React, { useEffect, useState, useMemo } from "react"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import {
  TextField,
  createTheme,
  ThemeProvider,
  useTheme,
  Box,
  IconButton,
  Tooltip,
  TablePagination,
} from "@mui/material"

import Swal from "sweetalert2"
import { styled } from "@mui/material/styles"
import { esES } from "@mui/material/locale"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import EditIcon from "@mui/icons-material/Edit"
import { useNavigate } from "react-router-dom"
import EliminarIcon from "../../../assets/iconos/Eliminar.ico"
import DetalleIcon from "../../../assets/iconos/Detalle.ico"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../utils/date/HHMMSSFormatHour"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import CustomBackdrop from "../../../components/CustomBackdrop"
const CustomTable = ({
  fetchedInfo = [],
  isLoadingInfoError,
  isLoadingInfo,
  isFetchingInfo,
  setProveedoresNoAsociados,
  refetch,
  setIsFormValid,
  selectedAvProvs,
  setSelectedAvProvs,
}) => {
  const navigate = useNavigate()
  // Maneja cambios en los filtros de la grilla
  const [editedExt, setEditedExt] = useState({})
  const columns = useMemo(
    () => [
      {
        accessorKey: "acciones",
        header: "Acciones",
        enableColumnFilter: false,
        size: 150,
      },
      {
        accessorKey: "procodigo",
        header: "Codigo",
        enableEditing: false,
        size: 120,
      },

      {
        accessorKey: "pronombre",
        header: "Nombre",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "proruc",
        header: "Identificacion",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "protelef1",
        header: "Telefono",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "extcodigo",
        header: "EXT",
        Cell: ({ cell, row }) => {
          const rowId = row.id // Obtener el ID de la fila
          return (
            <TextField
              value={editedExt[rowId] || cell.getValue() || ""}
              onChange={(e) => {
                const value = e.target.value
                // Actualizar el estado local y la propiedad extcodigo del objeto de la fila
                setEditedExt((prev) => ({
                  ...prev,
                  [rowId]: value,
                }))

                // Actualizar el valor en el objeto correspondiente
                row.original.extcodigo = value
              }}
              variant="outlined"
              size="small"
              // Desactivar el campo si la fila no está seleccionada
              disabled={!row.getIsSelected()}
            />
          )
        },
        enableColumnFilter: false,
        enableSorting: false,
        size: 200,
      },
    ],
    [editedExt],
  )

  const [rowSelection, setRowSelection] = useState({})
  const table = useMaterialReactTable({
    columns,
    data: fetchedInfo.length > 0 ? fetchedInfo : [],
    enableEditing: false,
    enableRowSelection: true,
    enableRowActions: false,
    onRowSelectionChange: setRowSelection,

    localization: { ...MRT_Localization_ES },
    initialState: {
      showColumnFilters: true,
    },
    getRowId: (row) => `${row.procodigo}`,
    muiToolbarAlertBannerProps:
      // searchAttempted &&
      !isLoadingInfo && fetchedInfo.length === 0 && !isFetchingInfo
        ? {
            color: "info",
            children: "No se encontraron Proovedores",
          }
        : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "500px",
      },
    },
    renderToolbarInternalActions: ({ table }) => <Box></Box>,

    state: {
      isLoading: isLoadingInfo,
      showAlertBanner: isLoadingInfoError,
      showProgressBars: isFetchingInfo,
      rowSelection,
    },
  })

  useEffect(() => {
    const selectedRowsData = table.getSelectedRowModel().flatRows.map((row) => row.original)
    setSelectedAvProvs(selectedRowsData)
    console.log(selectedAvProvs)
  }, [rowSelection, setSelectedAvProvs])
  const validateForm = () => {
    const allValid = table
      .getSelectedRowModel()
      .flatRows.every((row) => row.original.extcodigo && row.original.extcodigo.trim() !== "")
    setIsFormValid(allValid)
  }

  // Ejecutar la validación inicial cada vez que cambie la selección de filas o el contenido de `editedExt`
  useEffect(() => {
    validateForm()
  }, [editedExt, rowSelection])
  useEffect(() => {
    console.log("Seleccion actual:", selectedAvProvs)
  }, [selectedAvProvs])
  useEffect(() => {
    setProveedoresNoAsociados(fetchedInfo)
  }, [fetchedInfo])
  return (
    <>
      <MaterialReactTable table={table} />
    </>
  )
}

const ProvNoAsociadosGrid = ({
  refetch,
  fetchedInfo,
  isLoadingInfo,
  isError,
  isFetchingInfo,
  setProveedoresNoAsociados,
  selectedAvProvs,
  setIsFormValid,
  setSelectedAvProvs,
}) => {
  const theme = useTheme()

  // Maneja cambios en los filtros de la grilla

  return (
    <div>
      <ThemeProvider theme={createTheme(theme, esES)}>
        <CustomTable
          fetchedInfo={fetchedInfo}
          isLoadingInfoError={isError}
          isLoadingInfo={isLoadingInfo}
          isFetchingInfo={isFetchingInfo}
          refetch={refetch}
          setProveedoresNoAsociados={setProveedoresNoAsociados}
          selectedAvProvs={selectedAvProvs}
          setSelectedAvProvs={setSelectedAvProvs}
          setIsFormValid={setIsFormValid}
        />
      </ThemeProvider>
    </div>
  )
}

export default ProvNoAsociadosGrid
